
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import CampaignForm from './modules/CampaignForm';
import CampaignPreviewSection from './modules/CampaignPreviewSection';
import SubmitCampaignButton from './modules/SubmitCampaignButton';
import SuccessDialog from '@/components/dialog/SuccessDialog';
import useCampaignFormState from './hooks/useCampaignFormState';
import {useCampaignFetchData} from './hooks/useCampaignFetchData';
import useCampaignSubmit from './hooks/useCampaignSubmit';
import { Icons } from '@/icons';

const AddCampaignContent: React.FC = () => {
  const dispatch = useDispatch<any>();

  // --- State from custom hooks ---
  const form = useCampaignFormState();
  const { games, audiences, fetchAllData } = useCampaignFetchData(dispatch);
  const { handleSubmit, open, setOpen } = useCampaignSubmit({
    form,
    dispatch,
  });

  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  return (
    <div className='grid lg:grid-cols-2 gap-6'>
      <CampaignForm
        form={form}
        games={games}
        audiences={audiences}
      />

      <CampaignPreviewSection
        form={form}
        games={games}
        audiences={audiences}
      />

      <SubmitCampaignButton onClick={handleSubmit} disabled={!form.formIsValid} />

      <SuccessDialog
        open={open}
        onClose={() => setOpen(false)}
        icon={<Icons.Yohoo />}
        heading='Congratulations!!!!'
        subheading='Your campaign is submitted successfully for approval, will publish after checking.'
      />
    </div>
  );
};

export default AddCampaignContent;
